module.exports = __webpack_public_path__ + "img/pause-icon.903eaffe.svg";